import React from 'react';
import Proptypes from 'prop-types';
import { PiArrowFatUpFill } from "react-icons/pi";
import './Key.css';

export default function Key({ char, isPressed, size = "normal", icon}) {
  return (
    <div 
      className={`key ${isPressed ? 'key-container pressed' : 'key-container'} ${size}`} 
      id={char}>
        {icon ? <PiArrowFatUpFill/> : char}
    </div>
  )
}

Key.propTypes = {
    char: Proptypes.string,
    isPressed: Proptypes.bool,
    size: Proptypes.string,
    icon: Proptypes.bool,
};
